const CLOSE_DELAY = 400;

const linkDropdown = () => {
  const groups = document.querySelectorAll('.js-header-link-group');

  groups.forEach(group => {
    let closeTimeout;
    const trigger = group.querySelector('.header__link--has-dropdown');

    group.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      group.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    });

    group.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        group.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    });
  });
};

export default linkDropdown;
